import React, { Component } from 'react';
import { Tabs } from 'antd';
import axios from 'axios';
import MetaDecorator from '../../../components/MetaDecorator';  
import Loader from "react-loader-spinner";
import i18next from 'i18next';

const { TabPane } = Tabs;
class UserMyListing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paid_paginate : 0,
            booking_info_paid : [],                   
            is_loading : true,
            has_loadmore : true,
            has_loadmore1 : true,
            default_panel_active : "1",
        };
        this.booking_view = this.booking_view.bind(this)

    }
    componentDidMount = () => {
        if(this.props.location.state !== undefined) {
            if(this.props.location.state.status_of_booking === 'completed' || this.props.location.state.status_of_booking === 'cancelled' || this.props.location.state.status_of_booking === 'refunded') {
                this.setState({
                    default_panel_active : "2"
                })
            }
        }
        this.set_general_info();
    }
    set_general_info = () => {
        var user_info = JSON.parse(localStorage.getItem("user"));
        var general_info = JSON.parse(localStorage.getItem("general_info"));
        this.setState({
            general_info : general_info,
            user_info : user_info
        },()=>{
            this.get_paid_booking_details();
        })
    }
   

get_paid_booking_details = () => {
    console.log('paid called');
    var booking_info = this.state.booking_info_paid;
    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    const params = new URLSearchParams()
    params.append('user_id', this.state.user_info && this.state.user_info.user_id)
    params.append('limit', '10')
    params.append('offset', this.state.paid_paginate)
    params.append('type', 'paid')
     
    axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/listings`,params,config)
    .then (res=>{ 
        console.log('padinres',res.data)
        if(res.data.status_code === 200) {
            const monthNames = ["Jan", "Feb", "Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            // eslint-disable-next-line
            res.data.items.map((j,k)=>{
                var msg_chat = new Date(j.date);
                var elapsed_date = '';
                var month_name = monthNames[msg_chat.getMonth()];
                var year = msg_chat.getFullYear();
                var date = msg_chat.getDate();
                elapsed_date = date+'.'+month_name+'.'+year;
                res.data.items[k].formatted_date = elapsed_date;
                
            })
            if(res.data.items.length < 10) {
                this.setState({
                    has_loadmore1 : false
                })    
            }
            booking_info.push(res.data.items);
            var result = booking_info.flat();
            console.log('result',result)
            this.setState({ booking_info_paid: result, is_loading : false });
        }
        else if(res.data.status_code === 401) {
            // localStorage.removeItem('access_token');
            // localStorage.removeItem('user');
            // this.props.history.push('/');
            // window.location.reload(false);
        }
        else {
            this.setState({
                is_loading : false,
                has_loadmore1 : false
            })
        }
    })
}

    booking_view = (id) => {
        console.log('ID',id);
        
        var obj = {};
        obj.listing_id = id;
        console.log('OBJ',obj);
        
        this.props.history.push("/user/my-listing/detail",obj);
    }
    render() {
        return (
            <React.Fragment>
                <div className={ this.state.is_loading === true ?  "loadercls"  : "" }>
                <MetaDecorator title='| Need Page' description="IDemand User Need Page"/>
                {
                    this.state.is_loading === true ?
                    <div>
                        <Loader
                            type="ThreeDots"
                            color="#FF5800"
                            height={100}
                            width={100}
                        />
                    </div>
                    :
                    <div className="container">
                        <div className="pt-5">
                            <h4 className="fM mb-3">{ i18next.t('My Listings') }</h4>
                            {/* <Tabs defaultActiveKey={ this.state.default_panel_active } className="bookingTab"> */}
                                    {/* eslint-disable-next-line */}
                                    {this.state.booking_info_paid && this.state.booking_info_paid.length > 0 ? this.state.booking_info_paid.map((i) => {
                                        if((i.item_type === 'marketplace') || (i.item_type === 'professional') || (i.item_type === 'userneeds' && i.status !== 'cancelled')) {
                                        return (
                                            <div key={i} className="cardTwoStyle" onClick={ (e)=>{  e.stopPropagation(); this.booking_view(i.item_id); } }>
                                                    <div className="row cursorPointer">
                                                        <div className="col-sm-9 col-md-10">
                                                            <div className="row">
                                                                <div className="col-sm-4 col-lg-3">
                                                                    <img alt="" className="rounded imgBg" src={ i.item_image } height={100} />
                                                                </div>
                                                                <div className="col-sm-8 col-lg-9">
                                                                    <div className="detailsSection mt-3 mt-sm-0">
                                                                        <div className="detailsOne text-truncate">
                                                                        { i.item_name }
                                                                        </div>

                                                                            <div className="align-self-center font-sm mb-1">{ i.formatted_date }</div>
                                                                            {/* <div className="align-self-center font-sm mb-1"></div>
                                                                                <div className="align-self-center font-sm mb-1">ID: <span>#{i.reference_id}</span></div> */}

                                                                        <div className="detailsThree mb-0">
                                                                            {/* <div className="locationIcon align-self-center mr-2 mt-n1"></div> */}
                                                                            <div className="align-self-center text-truncate"></div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <div className="col-sm-3 col-md-2">
                                                            <div className="mt-3 mt-lg-0 text-right d-flex flex-wrap align-items-center justify-content-between d-lg-block">
                                                                <div className="detailsSection text-left text-sm-right mb-lg-2">
                                                                    <div className="detailsSix" style ={{color: "#FF5800"}}>
                                                                        { this.state.general_info && this.state.general_info.currency_code } { Math.floor(i.price )?.toLocaleString('en-US') } 
                                                        </div>
                                                            {
                                                                i.status === 'pending' ?
                                                                <p className="mb-0 fM greenTxtClr">{ i18next.t('Pending') }</p>
                                                                :
                                                                i.status === 'active' ?  
                                                                <p className="mb-0 fM greenTxtClr">{ i18next.t('Active') }</p>
                                                                :
                                                                i.status === 'deactive' &&  
                                                                <p className="mb-0 fM redTxtClr">{ i18next.t('Deactive') }</p>
                                                            }
                                                                </div>
                                                                

                                                            </div>

                                                        </div>
                                                    </div>
                                               

                                            </div>
                                        )
                                        }
                                    })
                                :
                                    <div className="d-grid place-items-center vh-50">
                                        <div>
                                            <img src={require("../../../assets/images/placeholder_logos(2).png")} alt=""
                                                className="placelogo-cls " />
                                            <div className="text-center font-xl py-3 fM">{ i18next.t('No Listings Found!') }</div>   
                                        </div>     
                                    </div>
                                }
                                    {
                                        this.state.has_loadmore1 === true &&
                                        <div className="m-3">
                                            <button onClick={ (e)=> { e.stopPropagation(); this.setState({ paid_paginate : this.state.paid_paginate + 10 },()=> {
                                                this.get_paid_booking_details();
                                            });   }  } type="button" className="loadMoreServices border-0 w-100">{ i18next.t('Load more') }</button>
                                        </div>
                                    }
                                    

                            {/* </Tabs> */}
                        
                        </div>
                    </div>
                }
                
               
                </div>
            </React.Fragment>
        );
    }
}

export default UserMyListing;